"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POINTER_DIRECTION_RIGHTWARD = exports.POINTER_DIRECTION_LEFTWARD = exports.POINTER_DIRECTION_UPWARD = exports.POINTER_DIRECTION_DOWNWARD = exports.ALIGNMENT_CENTER = exports.ALIGNMENT_RIGHT = exports.ALIGNMENT_LEFT = exports.ALIGNMENT_BOTTOM = exports.ALIGNMENT_TOP = exports.PLACEMENT_RIGHT = exports.PLACEMENT_LEFT = exports.PLACEMENT_BOTTOM = exports.PLACEMENT_TOP = void 0;
const PLACEMENT_TOP = 'top';
exports.PLACEMENT_TOP = PLACEMENT_TOP;
const PLACEMENT_BOTTOM = 'bottom';
exports.PLACEMENT_BOTTOM = PLACEMENT_BOTTOM;
const PLACEMENT_LEFT = 'left';
exports.PLACEMENT_LEFT = PLACEMENT_LEFT;
const PLACEMENT_RIGHT = 'right';
exports.PLACEMENT_RIGHT = PLACEMENT_RIGHT;
const ALIGNMENT_TOP = 'top';
exports.ALIGNMENT_TOP = ALIGNMENT_TOP;
const ALIGNMENT_BOTTOM = 'bottom';
exports.ALIGNMENT_BOTTOM = ALIGNMENT_BOTTOM;
const ALIGNMENT_LEFT = 'left';
exports.ALIGNMENT_LEFT = ALIGNMENT_LEFT;
const ALIGNMENT_RIGHT = 'right';
exports.ALIGNMENT_RIGHT = ALIGNMENT_RIGHT;
const ALIGNMENT_CENTER = 'center';
exports.ALIGNMENT_CENTER = ALIGNMENT_CENTER;
const POINTER_DIRECTION_DOWNWARD = 'downward';
exports.POINTER_DIRECTION_DOWNWARD = POINTER_DIRECTION_DOWNWARD;
const POINTER_DIRECTION_UPWARD = 'upward';
exports.POINTER_DIRECTION_UPWARD = POINTER_DIRECTION_UPWARD;
const POINTER_DIRECTION_LEFTWARD = 'leftward';
exports.POINTER_DIRECTION_LEFTWARD = POINTER_DIRECTION_LEFTWARD;
const POINTER_DIRECTION_RIGHTWARD = 'rightward';
exports.POINTER_DIRECTION_RIGHTWARD = POINTER_DIRECTION_RIGHTWARD;